import { colors, flex } from '@ebh/capsule/theme';
import { css } from '@emotion/react';

export const styles = {
  container: css`
    ${[
      flex('center', 'column'),
      {
        gap: '16px',
        height: '100vh',
        position: 'fixed' as const,
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      },
    ]}
  `,
  spinner: css`
    ${{ color: colors['primary-400'] }}
  `,
  text: css`
    ${{
      color: colors['primary-400'],
      fontSize: '14px',
      fontWeight: 500,
      letterSpacing: '0.3px',
    }}
  `,
};
